import { ICod } from '../cod.interface';

export interface ICodDomestic extends ICod {
    relatedNumber?: string;
    relatedTrackingNumber?: string;
    additionalInfo?: string;
    managerGid?: string;
    filedWithin30Days?: boolean;
}
